module.exports = __webpack_public_path__ + "static/media/optionPlusActive.20135769.svg";